/**
 * Portuguese Technology Translations
 * 技术页翻译模块 - 葡萄牙语
 * 
 * 包含红外技术原理、技术优势、科学原理等翻译
 */

import type { TechnologyTranslations } from '../../types';

export const ptTechnology: TechnologyTranslations = {
  title: 'A Ciência do Calor',
  subtitle: 'Descubra como a tecnologia de infravermelho distante oferece aquecimento mais eficiente e confortável para o seu espaço.',
  section1: {
    title: 'Como a Luz do Sol, em Todo o Ambiente',
    desc1: 'Aquecedores tradicionais aquecem principalmente o ar. Como o ar quente sobe para o teto, isso gera temperaturas desiguais e levanta poeira.',
    desc2: 'O aquecimento por infravermelho distante funciona de outro jeito. Como o sol, ele emite ondas eletromagnéticas que aquecem diretamente objetos e pessoas. Paredes, pisos e móveis absorvem esse calor e o liberam aos poucos, mantendo o ambiente estável e confortável.',
    radiant: 'Transferência de Calor Radiante',
  },
  section2: {
    title: 'Tecnologia Central de Aquecimento',
    intro: 'Nosso elemento de aquecimento especialmente projetado, combinado com nosso nanorrevestimento patenteado, entrega desempenho térmico excepcional.',
    surface: 'Nanorrevestimento',
    surfaceDesc: 'O nanorrevestimento patenteado aumenta significativamente a área de radiação e atinge emissividade de 86%.',
    rapid: 'Aquecimento Rápido',
    rapidDesc: 'O alumínio de alta condutividade atinge a temperatura ideal em apenas 5 minutos.',
    durability: 'Vida Útil Ultralonga',
    durabilityDesc: 'Projetado para mais de 25 anos de operação sem manutenção.',
    nanoTitle: 'Nanotecnologia',
  },
  infraredIntroduction: {
    title: 'Tecnologia Avançada de Infravermelho Distante',
    desc: 'Aproveita a parte invisível do espectro da luz para alcançar eficiência térmica superior. Nossa tecnologia otimiza a faixa de infravermelho distante para maximizar a absorção de calor pelo corpo humano.',
    optimalWavelength: 'Comprimento de Onda Ideal',
    optimalWavelengthDesc: 'Ajustado para a frequência específica que entra em ressonância natural com as moléculas de água do corpo, garantindo máxima absorção e retenção de calor.',
    superiorEfficiency: 'Eficiência Superior',
    superiorEfficiencyDesc: 'Supera as faixas de infravermelho próximo e médio. O infravermelho distante entrega calor suave e uniforme, sem sensação de calor agressivo e sem ressecar o ar.',
    radiantEnergy: 'Energia Radiante',
    radiantEnergyDesc: 'Libera calor radiante puro, que vai direto para objetos e pessoas, sem depender da circulação de ar e evitando desperdício de energia.',
  },
  healthBenefits: {
    title: 'Além do Aquecimento: Os Benefícios para a Saúde',
    desc: 'O infravermelho distante vai além de aquecer. Seu comprimento de onda único ajuda a criar um ambiente mais saudável e confortável, apoiando ativamente o seu bem-estar.',
    card1: {
      title: 'A "Luz da Vida"',
      desc: 'Ao operar na faixa de 8 a 15 μm, esse calor corresponde naturalmente à frequência do seu corpo. O resultado é um aquecimento suave, de absorção profunda e sensação natural.',
    },
    card2: {
      title: 'Respiração Limpa',
      desc: 'Diferentemente dos aquecedores tradicionais por convecção, não levanta poeira, não espalha alérgenos nem resseca o ar, protegendo a pele e a saúde respiratória.',
    },
    card3: {
      title: 'Calor Profundo e Relaxante',
      desc: 'As ondas térmicas de penetração profunda ajudam a estimular a microcirculação, relaxar os músculos e aliviar a rigidez comum no inverno.',
    },
  },
};
